module.exports = __webpack_public_path__ + "static/img/bao.5f158a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/bao.png
// module id = /dnB
// module chunks = 2